// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file penumbra/crypto/tct/v1/tct.proto (package penumbra.crypto.tct.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
/**
 * @generated from message penumbra.crypto.tct.v1.StateCommitment
 */
export class StateCommitment extends Message {
    /**
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.crypto.tct.v1.StateCommitment";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new StateCommitment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StateCommitment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StateCommitment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StateCommitment, a, b);
    }
}
/**
 * @generated from message penumbra.crypto.tct.v1.MerkleRoot
 */
export class MerkleRoot extends Message {
    /**
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.crypto.tct.v1.MerkleRoot";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new MerkleRoot().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MerkleRoot().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MerkleRoot().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MerkleRoot, a, b);
    }
}
/**
 * An authentication path from a state commitment to the root of the state commitment tree.
 *
 * @generated from message penumbra.crypto.tct.v1.StateCommitmentProof
 */
export class StateCommitmentProof extends Message {
    /**
     * @generated from field: penumbra.crypto.tct.v1.StateCommitment note_commitment = 1;
     */
    noteCommitment;
    /**
     * @generated from field: uint64 position = 2;
     */
    position = protoInt64.zero;
    /**
     * always length 24
     *
     * @generated from field: repeated penumbra.crypto.tct.v1.MerklePathChunk auth_path = 3;
     */
    authPath = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.crypto.tct.v1.StateCommitmentProof";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "note_commitment", kind: "message", T: StateCommitment },
        { no: 2, name: "position", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "auth_path", kind: "message", T: MerklePathChunk, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new StateCommitmentProof().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StateCommitmentProof().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StateCommitmentProof().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StateCommitmentProof, a, b);
    }
}
/**
 * A set of 3 sibling hashes in the auth path for some note commitment.
 *
 * @generated from message penumbra.crypto.tct.v1.MerklePathChunk
 */
export class MerklePathChunk extends Message {
    /**
     * @generated from field: bytes sibling_1 = 1;
     */
    sibling1 = new Uint8Array(0);
    /**
     * @generated from field: bytes sibling_2 = 2;
     */
    sibling2 = new Uint8Array(0);
    /**
     * @generated from field: bytes sibling_3 = 3;
     */
    sibling3 = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.crypto.tct.v1.MerklePathChunk";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "sibling_1", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 2, name: "sibling_2", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 3, name: "sibling_3", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new MerklePathChunk().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MerklePathChunk().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MerklePathChunk().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MerklePathChunk, a, b);
    }
}
